import { render, staticRenderFns } from "./LpuLoyaltyProgramInfo.vue?vue&type=template&id=b0bacb14&"
import script from "./LpuLoyaltyProgramInfo.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuLoyaltyProgramInfo.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0bacb14')) {
      api.createRecord('b0bacb14', component.options)
    } else {
      api.reload('b0bacb14', component.options)
    }
    module.hot.accept("./LpuLoyaltyProgramInfo.vue?vue&type=template&id=b0bacb14&", function () {
      api.rerender('b0bacb14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/LpuLoyaltyProgram/components/LpuLoyaltyProgramInfo/LpuLoyaltyProgramInfo.vue"
export default component.exports